import GeneralImageNew from '@gp/components/GeneralImageNew';
import InfoBubble from '@gp/components/InfoBubble';
import LinkJump from '@gp/components/LinkJump';
import TextAreaMore from '@gp/components/TextAreaMore';
import '@gp/pages/Pipeline/ProjectDetails/Stakeholder/components/StakeholderDetails/components/EmployeeInfo/index.scss';
import { EmployeeInfoPropsType } from '@gp/pages/Pipeline/ProjectDetails/Stakeholder/types';
import { getTencentAvatarSrc, isLegalHttpUrl, queryJumpable } from '@gp/utils/common';
import classnames from 'classnames';
import React, { useMemo, useState } from 'react';

import InSvg from '@gp/assets/svg/in.svg';
import DEFAULT_USER_ICON from '@home/assets/img/common/user-avatar-default.svg';

// linkein官网
const LINKEIN_OFFICIAL_URL = 'https://www.linkedin.com/home';
const IEGG_POSITION_MAP: any = {
  business_owner: 'Business Owner',
  pteam_contact: 'P-team Contact',
  finance_contact: 'Finance Contact',
};

const EmployeeInfo: React.FC<EmployeeInfoPropsType> = (props) => {
  const { organization, name, image_url, position, link } = props;

  const [visibleBubble, setVisibleBubble] = useState<boolean>(false);

  const organizationLowerCase = useMemo<string>(
    () => organization?.toLowerCase() || '',
    [organization],
  );
  const isIn = useMemo<boolean>(() => !!link, [link]);

  // 仅IEGG需要拉用户表头像，其他均使用默认头像
  const avatar = useMemo<string>(() => {
    if (image_url) return image_url;
    if ('iegg' !== organizationLowerCase?.toLowerCase()) return DEFAULT_USER_ICON;
    return getTencentAvatarSrc(name, 150);
  }, [organizationLowerCase, name, image_url]);

  const handleLink = (isJump = true): string => {
    if (!isIn) return '';
    let url = isLegalHttpUrl(link || '', false) ? link || '' : LINKEIN_OFFICIAL_URL;
    const hasProtocal = url?.startsWith('http://') || url?.startsWith('https://');
    url = hasProtocal ? url : `http://${url}`;
    if (isJump) {
      window.open(url);
    }

    return url;
  };
  const textInfo = useMemo(() => {
    return IEGG_POSITION_MAP?.[position] ? IEGG_POSITION_MAP?.[position] : position;
  }, [position]);

  return (
    <div className="employee-info">
      <GeneralImageNew
        domain="user"
        width={72}
        height={72}
        src={avatar}
        className="employee-info-img"
      />
      <div className="employee-info-item">
        <LinkJump style={{ color: '#000' }} url={handleLink(false)}>
          <div
            className="employee-name"
            onClick={(e) => {
              if (!queryJumpable(e)) return;
              handleLink(true);
            }}
          >
            <span className={classnames({ 'has-flag-icon': !!isIn })}>{name}</span>
            {['studio'].includes(organizationLowerCase) && !!isIn && (
              <img className="employee-flag-icon" src={InSvg} alt="" />
            )}
          </div>
        </LinkJump>
        <InfoBubble
          className="globalpedia-modal-font14"
          customBubbleContent={visibleBubble ? textInfo : undefined}
          DomOrText={
            <TextAreaMore
              isMustNoButton
              className="employee-desc gp-word-break-word"
              type="ellipsis"
              ellipsisLineClamp={2}
              lineHeight={22}
              text={textInfo}
              getIsFold={(v: boolean) => setVisibleBubble(v)}
            />
          }
        />
      </div>
    </div>
  );
};

export default React.memo(EmployeeInfo);
